import { useState, useEffect } from 'react';
import { fetchArtists } from '../services/strapi';
import ArtistCard from './ArtistCard';
const Artists = () => {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getArtists = async () => {
      try {
        setLoading(true);
        const data = await fetchArtists(); // Call fetchArtists
        console.log("Fetched Artist Data:", data); // Log fetched data for debugging
        setArtists(data); // Update state with fetched artists
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getArtists();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;


  return (
    <>
    <div className='artists-grid'>
        {artists.map(artist => (
                <ArtistCard key={artist.id} artist={artist} />
            ))}
            </div>
    </>
  );
};

export default Artists;
